import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=419724c6&"
import script from "./bar.vue?vue&type=script&lang=js&"
export * from "./bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bar.vue"
export default component.exports